var e = {};
export {
  e as __exports
};
//# sourceMappingURL=index.es167.js.map
